// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"0b20aae2","213":"0e7c5a77","453":"79598f68"}[chunkId] + ".chunk.js";
};